import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogicService {

  constructor() { }

  private decToHex = new BehaviorSubject<string>('');
  private decToBin = new BehaviorSubject<string>('');
  private hexToDec = new BehaviorSubject<string>('');
  private hexToBin = new BehaviorSubject<string>('');
  private binToDec = new BehaviorSubject<string>('');
  private binToHex = new BehaviorSubject<string>('');

  convertValue(num: string) {
    this.decToHex.next(parseInt(num, 10).toString(16));
    this.decToBin.next(parseInt(num, 10).toString(2));
    this.hexToDec.next(parseInt(num, 16).toString(10));
    this.hexToBin.next(parseInt(num, 16).toString(2));
    this.binToDec.next(parseInt(num, 2).toString(10));
    this.binToHex.next(parseInt(num, 2).toString(16));
  }

  getValues(cnt: number){
    if(cnt === 0) { return this.decToHex.asObservable(); }
    else if(cnt === 1) {return this.decToBin.asObservable();}
    else if(cnt === 2) {return this.hexToDec.asObservable();}
    else if(cnt === 3) {return this.hexToBin.asObservable();}
    else if(cnt === 4) {return this.binToDec.asObservable();}
    else if(cnt === 5) {return this.binToHex.asObservable();}
  }
}
